var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18.1",
    width: 15,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8e8e8e;fill-rule:evenodd;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "9b52b8e5-067a-4267-95bf-348ae06549fd.psd",
    id: "_9b52b8e5-067a-4267-95bf-348ae06549fd.psd"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon-paperclip copy",
    id: "icon-paperclip_copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.9,1.09a3.79,3.79,0,0,0-5.32,0l-10,9.85L3.53,11h0a2.47,2.47,0,0,0,.14,3.37,2.55,2.55,0,0,0,3.57,0l6.54-6.48s.29-.28.05-.54A2.94,2.94,0,0,0,13.47,7a.42.42,0,0,0-.52.06L6.41,13.57a1.34,1.34,0,0,1-1.88,0,1.31,1.31,0,0,1,0-1.86l9.9-9.79a2.59,2.59,0,0,1,3.63,0,2.52,2.52,0,0,1,0,3.59l-10,9.85-.47.47a3.8,3.8,0,0,1-5.33,0,3.7,3.7,0,0,1,0-5.27L8.08,4.8a.32.32,0,0,0,0-.45,5.65,5.65,0,0,0-.45-.45c-.21-.17-.43.07-.43.07L1.45,9.72a4.87,4.87,0,0,0,0,6.94,5,5,0,0,0,7,0L18.9,6.34a3.69,3.69,0,0,0,0-5.26Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.cbcbdae48751e74aea55abb1edc4a7b3.svg";
export { ForwardRef as ReactComponent };